(function () {
  'use strict';
  if (window.BeryloveWarehouseBadges) return;

  var dataSelector = '[data-warehouse-inventory]';
  var states = new WeakMap();

  function owned(form, selector) {
    return Array.from(form.querySelectorAll(selector)).filter(function (node) {
      return node.closest('form') === form;
    });
  }

  function stateFor(form) {
    if (!states.has(form)) states.set(form, { explicit: false });
    return states.get(form);
  }

  function readData(form) {
    var sources = owned(form, dataSelector);
    // Ambiguous or malformed data must never borrow another product's snapshot.
    if (sources.length !== 1) return { variants: [], assets: {} };
    try {
      var data = JSON.parse(sources[0].textContent);
      if (!data || !Array.isArray(data.variants)) throw new Error('Invalid snapshot');
      data.variants = data.variants.filter(function (variant) {
        return variant && variant.id != null && Array.isArray(variant.options);
      });
      return data;
    } catch (error) {
      return { variants: [], assets: {} };
    }
  }

  function variantById(variants, id) {
    var matches = variants.filter(function (variant) { return String(variant.id) === String(id); });
    return matches.length === 1 ? matches[0] : null;
  }

  function variantByOptions(variants, options) {
    var matches = variants.filter(function (variant) {
      return options.length === variant.options.length && options.every(function (value, index) {
        return typeof value === 'string' && value !== '' && value === variant.options[index];
      });
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function hasStock(warehouse) {
    if (!warehouse || typeof warehouse !== 'object' || Array.isArray(warehouse)) return false;
    var status = typeof warehouse.status === 'string' ? warehouse.status.trim().toLowerCase() : '';
    if (status !== 'available' && status !== '可用') return false;
    var quantity = warehouse.quantity;
    if (typeof quantity !== 'number' && typeof quantity !== 'string') return false;
    if (typeof quantity === 'string' && !/^-?\d+(?:\.\d+)?$/.test(quantity.trim())) return false;
    return Number.isFinite(Number(quantity)) && Number(quantity) > 0;
  }

  function warehouseFor(variant) {
    // A display exception derived from this variant's size option, not another inventory source.
    if (variant && variant.excludeWarehouseBadge === true) return '';
    var warehouses = variant && variant.warehouses;
    if (!warehouses || typeof warehouses !== 'object' || Array.isArray(warehouses)) return '';
    if (hasStock(warehouses.us)) return 'us';
    if (hasStock(warehouses.local)) return 'local';
    return '';
  }

  function optionIndex(selector, fallback) {
    var named = selector.getAttribute('data-option') || selector.getAttribute('data-index') || '';
    if (/^option[1-3]$/.test(named)) return Number(named.slice(-1)) - 1;
    var indexed = selector.getAttribute('data-option-index');
    if (indexed !== null && /^[0-2]$/.test(indexed)) return Number(indexed);
    var suffix = /-option-([0-2])$/.exec(selector.id);
    return suffix ? Number(suffix[1]) : fallback;
  }

  function selectedOptions(form, data, state) {
    var idControl = owned(form, 'select[name="id"], input[name="id"]')[0];
    var selected = variantById(data.variants, idControl ? idControl.value : data.selectedVariantId);
    if (!selected && !idControl) selected = data.variants.length === 1 ? data.variants[0] : null;
    if (state.explicit) {
      var explicit = variantById(data.variants, state.variantId);
      if (explicit) return explicit.options.slice();
    }
    var count = data.variants.reduce(function (max, variant) { return Math.max(max, variant.options.length); }, 0);
    var options = selected ? selected.options.slice() : new Array(count).fill('');
    owned(form, 'select.single-option-selector:not([data-warehouse-ignore])').forEach(function (selector, index) {
      options[optionIndex(selector, index)] = selector.value;
    });
    // Real swatches override the generated, hidden OptionSelectors dropdowns.
    owned(form, '.swatch[data-option-index]').forEach(function (swatch) {
      var index = Number(swatch.getAttribute('data-option-index'));
      var input = swatch.querySelector('input[type="radio"]:checked');
      if (input && index >= 0 && index < count) options[index] = input.value;
    });
    return options;
  }

  function render(badge, warehouse, assets) {
    var source = warehouse && assets && assets[warehouse];
    var key = typeof source === 'string' && source.trim() ? warehouse + ':' + source : '';
    // Reuse an unchanged image. A failed URL stays hidden until the snapshot changes.
    if (badge.__warehouseKey === key) return !badge.hidden;
    badge.__warehouseKey = key;
    badge.replaceChildren();
    badge.hidden = true;
    badge.removeAttribute('data-warehouse');
    if (!key) return false;
    var image = document.createElement('img');
    image.src = source;
    image.alt = warehouse === 'us' ? 'US Warehouse' : '48 hours';
    image.width = 90;
    image.height = 30;
    image.draggable = false;
    image.addEventListener('error', function () {
      if (image.parentNode !== badge) return;
      badge.replaceChildren();
      badge.hidden = true;
      badge.removeAttribute('data-warehouse');
      var single = badge.closest('[data-warehouse-single]');
      if (single) single.hidden = true;
    });
    badge.appendChild(image);
    badge.setAttribute('data-warehouse', warehouse);
    badge.hidden = false;
    return true;
  }

  function refreshForm(form) {
    if (!form.isConnected) return;
    var data = readData(form);
    var state = stateFor(form);
    var options = selectedOptions(form, data, state);
    var groups = owned(form, '.swatch[data-warehouse-option][data-option-index]');
    groups.forEach(function (group) {
      var index = Number(group.getAttribute('data-option-index'));
      Array.from(group.querySelectorAll('.swatch-element[data-value]')).forEach(function (element) {
        var badge = element.querySelector('[data-warehouse-badge]');
        if (!badge) return;
        var candidate = options.slice();
        candidate[index] = element.getAttribute('data-value');
        render(badge, data.variants.length === 1 ? '' : warehouseFor(variantByOptions(data.variants, candidate)), data.assets);
      });
    });
    var current = state.explicit && state.variantId == null ? null : variantByOptions(data.variants, options);
    owned(form, '[data-warehouse-single]').forEach(function (single) {
      var badge = single.querySelector('[data-warehouse-badge]');
      var show = data.variants.length === 1 || groups.length === 0;
      single.hidden = !render(badge, show ? warehouseFor(current) : '', data.assets);
    });
    // Also remove previous results if a section's data is removed or broken.
    if (!data.variants.length) owned(form, '[data-warehouse-badge]').forEach(function (badge) { render(badge, '', {}); });
  }

  function formsWithin(root) {
    root = root && root.querySelectorAll ? root : document;
    var forms = new Set();
    var enclosing = root.closest && root.closest('form');
    if (enclosing && (states.has(enclosing) || enclosing.querySelector(dataSelector))) forms.add(enclosing);
    if (root.matches && root.matches(dataSelector) && root.closest('form')) forms.add(root.closest('form'));
    root.querySelectorAll(dataSelector).forEach(function (source) {
      if (source.closest('form')) forms.add(source.closest('form'));
    });
    return forms;
  }

  function refresh(root) { formsWithin(root).forEach(refreshForm); }

  function schedule(form) {
    if (!form || !form.querySelector(dataSelector)) return;
    var state = stateFor(form);
    window.clearTimeout(state.soon);
    window.clearTimeout(state.settled);
    state.soon = window.setTimeout(function () { refreshForm(form); }, 0);
    state.settled = window.setTimeout(function () { refreshForm(form); }, 80);
  }

  function handleControl(event) {
    if (!(event.target instanceof Element)) return;
    var control = event.target.closest('.swatch-element, .single-option-selector, select[name="id"], input[name="id"]');
    var form = control && control.closest('form');
    if (!form || !form.querySelector(dataSelector)) return;
    var state = stateFor(form);
    state.explicit = control.matches('[name="id"]');
    state.variantId = control.value;
    schedule(form);
  }

  document.addEventListener('click', handleControl);
  document.addEventListener('change', handleControl);
  document.addEventListener('warehouse:variant-change', function (event) {
    var form = event.target.closest && event.target.closest('form');
    if (!form || !form.querySelector(dataSelector)) return;
    var state = stateFor(form);
    state.explicit = true;
    state.variantId = event.detail ? event.detail.variantId : null;
    schedule(form);
  });
  document.addEventListener('shopify:section:load', function (event) { refresh(event.target); });
  document.addEventListener('DOMContentLoaded', function () { refresh(); });
  window.addEventListener('load', function () { refresh(); });

  // Covers OptionSelectors initialization and AJAX quickview/cart-edit insertion.
  var pendingForms = new Set();
  var observerTimer;
  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (!target || target.closest('[data-warehouse-badge]')) return;
      var form = target.closest('form');
      if (form && (states.has(form) || form.querySelector(dataSelector))) pendingForms.add(form);
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) formsWithin(node).forEach(function (addedForm) { pendingForms.add(addedForm); });
      });
    });
    if (!pendingForms.size) return;
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(function () {
      var forms = Array.from(pendingForms);
      pendingForms.clear();
      forms.forEach(refreshForm);
    }, 16);
  });
  if (document.body) observer.observe(document.body, { childList: true, characterData: true, subtree: true });

  // Uses only Liquid-provided data and current DOM; makes no network requests.
  window.BeryloveWarehouseBadges = {
    refresh: refresh,
    resolveWarehouse: function (warehouses) { return warehouseFor({ warehouses: warehouses }); }
  };
  refresh();
})();
